import { render, staticRenderFns } from "./WidgetCreateUpdateCarousel.vue?vue&type=template&id=dbfa1cf6&scoped=true"
import script from "./WidgetCreateUpdateCarousel.vue?vue&type=script&lang=js"
export * from "./WidgetCreateUpdateCarousel.vue?vue&type=script&lang=js"
import style0 from "./WidgetCreateUpdateCarousel.vue?vue&type=style&index=0&id=dbfa1cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfa1cf6",
  null
  
)

export default component.exports